import { Container, Grid, GridItem, Box } from '@chakra-ui/react';
import PressCard from './PressCard';
import { PrimaryButton } from './Button';
import { useState } from 'react';

export default function PressCards({ cards }) {
  const [itemsToShow, SetItemsToShow] = useState(6);

  const handleMore = () => {
    SetItemsToShow(itemsToShow + 6);
  };

  return (
    <Container>
      <Grid
        gap={{ base: '8' }}
        gridTemplateColumns={{
          md: 'repeat(2, 1fr)',
          lg: 'repeat(3, 1fr)',
        }}
      >
        {cards.slice(0, itemsToShow).map((card) => (
          <GridItem key={card.title}>
            <PressCard card={card} />
          </GridItem>
        ))}
      </Grid>
      {cards.length > itemsToShow && (
        <Box textAlign="center">
          <PrimaryButton mt="12" onClick={handleMore}>
            Load More
          </PrimaryButton>
        </Box>
      )}
    </Container>
  );
}
